import { useCallback } from "react";
import { TooltipProvider } from "@flight-tools/ui";
import { CookieConsentBanner } from "@flight-tools/consent";
import { useTranslation } from "@flight-tools/i18n";
import { initBrowserTelemetry } from "@flight-tools/telemetry";
import { SeatCalculator } from "./features/seat-calculator/SeatCalculator";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

export function App() {
  const { currentLanguage } = useTranslation();

  const handleAcceptAnalytics = useCallback(() => {
    const collectorUrl = import.meta.env.VITE_OTEL_COLLECTOR_URL;
    if (collectorUrl) {
      initBrowserTelemetry({
        serviceName: "flight-tools-web",
        serviceVersion: "0.0.1",
        collectorUrl,
        enabled: true,
      });
    }
  }, []);

  const handleRejectAnalytics = useCallback(() => {
    // Analytics rejected - nothing to do
  }, []);

  return (
    <TooltipProvider>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="container mx-auto flex-1 px-4 py-8">
          <SeatCalculator />
        </main>
        <Footer />
        <CookieConsentBanner
          currentLanguage={currentLanguage}
          onAcceptAnalytics={handleAcceptAnalytics}
          onRejectAnalytics={handleRejectAnalytics}
        />
      </div>
    </TooltipProvider>
  );
}
